import { useField } from "formik";
import React from "react";
import { FormFieldProps } from "../interfaces";
import Input from "../index";

interface Props extends FormFieldProps {
  placeholder?: string;
  type: "text" | "email";
}

const InputField: React.FC<Props> = (props) => {
  const [field, meta] = useField(props);

  return (
    <Input
      {...field}
      {...props}
      hasError={!!(meta.error && meta.touched)}
      errorMessage={meta.error}
    />
  );
};

export default InputField;
